import React, { useState } from "react";
import { 
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { DASHBOARD_TYPE } from "src/constant/common";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const Series6DofDashboard = ({
  handleClickAscent, 
  handleClickDescent, 
  handleGetErrorMetricsDashboard,
  handleGetRssMetricsDashboard,
  isDispersionAnalysis,
  id, 
  isLoading, 
  isShow = true, 
  serieData 
}) => {
  const { t } = useTranslation("flight-simulator");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const isDashboardReady = (type) => {
    return !!serieData.simulator_dashboards.filter(item => item.dashboard_type === type)?.[0]?.dashboard_url;
  }

  return (
    isShow ? (
      isLoading ? (
        <Spinner size="sm" color="secondary" className="m-l-6"/>
      ) : (
        <TooltipWrapper
          tooltipText={t("list.table.dashboard")}
          id={`dashboard-serie-${id}`}
        >
          <Dropdown
            isOpen={dropdownOpen}
            toggle={toggleDropdown}
            className="align-self-center"
          >
            <DropdownToggle
              data-toggle="dropdown"
              tag="button"
              className="border-0 bg-transparent"
            >
              <i className={`bi bi-speedometer2 ${serieData.simulator_dashboards.length > 1 ? 'text-success' : 'text-dark'} f-s-20`}/>
            </DropdownToggle>
            
            <DropdownMenu
              className="topbar-dropdown-menu profile-dropdown-items"
              container=".navbar"
            >
               {
                  isDispersionAnalysis ? (
                    <div onClick={toggleDropdown}>
                      <div
                        role="button"
                        className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.ASCENT_6DOF) ? 'text-success' : 'text-dark'}`}
                        onClick={handleClickAscent}
                      >
                        <span>{t('list.table.ascending_dashboard')}</span>
                      </div>
                      <div
                        role="button"
                        className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.DESCENT_6DOF) ? 'text-success' : 'text-dark'}`}
                        onClick={handleClickDescent}
                      >
                        <span>{t('list.table.descending_dashboard')}</span>
                      </div>
                      <div
                        role="button"
                        className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.DISPERSION_ERROR_6DOF) ? 'text-success' : 'text-dark'}`}
                        onClick={handleGetErrorMetricsDashboard}
                      >
                        <span>{t('list.table.dispersion_error_dashboard')}</span>
                      </div>
                      <div
                        role="button"
                        className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.DISPERSION_RSS_6DOF) ? 'text-success' : 'text-dark'}`}
                        onClick={handleGetRssMetricsDashboard}
                      >
                        <span>{t('list.table.dispersion_rss_dashboard')}</span>
                      </div>
                    </div>
                  ) : (
                    <div onClick={toggleDropdown}>
                      <div
                        role="button"
                        className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.ASCENT_6DOF) ? 'text-success' : 'text-dark'}`}
                        onClick={handleClickAscent}
                      >
                        <span>{t('list.table.ascending_dashboard')}</span>
                      </div>
                      <div
                        role="button"
                        className={`dropdown-item ${isDashboardReady(DASHBOARD_TYPE.DESCENT_6DOF) ? 'text-success' : 'text-dark'}`}
                        onClick={handleClickDescent}
                      >
                        <span>{t('list.table.descending_dashboard')}</span>
                      </div>
                    </div>
                  )
                }
            </DropdownMenu>
          </Dropdown>
        </TooltipWrapper>
      )
    ) : null
  );
};

export default Series6DofDashboard;
